// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"5a59982e","732":"4a556bb3","977":"19df6f7c"}[chunkId] + ".chunk.js";
};